import styled from 'styled-components';

export const PermissionFlagWrapper = styled.div`
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: -0.11px;
  line-height: 16px;
  border-radius: 0 4px 0 0;
  background: #fa8c16;
  padding: 5px 4px;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
`;
